export const gettingStarted = {
    height:'100vh',
    padding: '0rem rem'
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems:'center',
    // background: 'blue'
    // '&::-webkit-scrollbar': {
    //     width: '0.4em'
    //   },
    // '-ms-overflow-style': 'none',  /* IE and Edge */
    // 'scrollbar-width': 'none',  /* Firefox */
    // boxShadow: 24,
}
export const gettingStartedStepper = {
 
    bgcolor: 'blue',
    color: 'white',
  
}
export const gettingStartedProgressContainer = {
    bgcolor: 'background.paper',
    p:4,
    borderRadius:"8px",
}
export const gettingStarted_btn_container = {
    display:"flex",
    justifyContent: "space-between",
}
export const btn = {
    borderRadius:"8px",
    width: "8rem",
    display: 'flex',
    alignItems:'center'
}
export const back_btn = {
    alignSelf: 'self-end',
}